<template>
  <vue-recaptcha
    @verify="recaptchaVerified"
    sitekey="6Le6Yh0UAAAAAAIXpmakytZapEhClcoswljficew"
  ></vue-recaptcha>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'Recaptcha',
  components: {
    VueRecaptcha,
  },
  created() {
    this.insertRecaptcha();
  },
  methods: {
    insertRecaptcha() {
      const src = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=pt-BR';
      if (document.querySelector(`script[src='${src}']`)) {
        return;
      }
      const script = document.createElement('script');
      script.setAttribute('src', src);
      script.setAttribute('type', 'text/javascript');
      document.body.appendChild(script);
    },
    recaptchaVerified() {
      this.$emit('recaptcha-event');
    },
  },
};
</script>

<style  lang="scss" scoped>
</style>
